export default {
    imageDashboardTransaction: {
        action: 'Action',
        transactionId: 'Transaction Id',
        variationCount: 'Nombre de variations',
        date: 'Date',
        description: 'Description',
        selectedImage: 'Selected Image',
        goTo: 'Aller à',
    },
};
